import { CircularProgress, Grid, Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import GridItem from '@/components/GridItem/index.js';
import CenterBox from '@/components/CenterBox/index.js';
import { CalendarMonthOutlined, LoginOutlined, LogoutOutlined, QuestionMarkOutlined } from '@mui/icons-material';
import VastaanottoVaraukset from '@/components/VastaanottoVaraukset/index.js';
import DashboardStats from '@/components/DashboardStats/DashboardStats';
import ReservationSourceTile from '@/components/DashboardStats/ReservationSourceTile';

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <CenterBox>
      <Grid container spacing={1} rowSpacing={3} alignItems="stretch">
        <Grid size={6}>
          <GridItem component={Link} to="/kalenteri" aria-label="Kalenterit" clickable>
            <CalendarMonthOutlined />
            <Typography>
              {t('dashboard.calendars')}
            </Typography>
          </GridItem>
        </Grid>
        <Grid size={6}>
          <ReservationSourceTile />
        </Grid>
        <DashboardStats />
        <Grid size={12}>
          <VastaanottoVaraukset />
        </Grid>
      </Grid>
    </CenterBox>
  );
};

export default Dashboard;
